import BalanceIcon from './BalanceIcon';

export default BalanceIcon;
